module.exports = __webpack_public_path__ + "media/images/icon_similar_white-fb25e03b0cf651723ccdc63a85cba0d7.svg";